<template>
  <a-modal
    :title="title"
    :width="800"
    :ok="false"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    okText="确认">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="组织名称"
          hasFeedback >
          <a-input placeholder="请输入组织名称" v-decorator="['name', { rules: [{ required: true, message: '请输入组织名称!' }] } ]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="简称">
          <a-input placeholder="请输入简称" v-decorator="['shortName']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="组织编码"
          hasFeedback >
          <a-input placeholder="请输入组织编码" v-decorator="['code', { rules: [{ required: true, message: '请输入组织编码!' }] } ]"/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" label="上级组织" hasFeedback>
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :treeData="departmentTree"
            v-model="model.parentCode"
            placeholder="请选择上级组织"
            disabled>
          </a-tree-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="排序">
          <a-input-number placeholder="请输入组织排序" style="width: 200px" v-decorator="[ 'orderCode' ]"/>
        </a-form-item>
        <a-form-item 
          label="备注" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remark']" :rows="4" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="启用">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="enable"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { addDepartment } from '@/baseAPI/department'
import pick from 'lodash.pick'
export default {
  name: 'DepartmentModal',
  data () {
    return {
      enable: true,
      departmentTree: [],
      title: '操作',
      seen: false,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  created () {
  },
  methods: {
    add (depart, treeData) {
      this.departmentTree = treeData
      if (depart) {
        this.seen = false
      } else {
        this.seen = true
      }
      this.edit(depart)
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, {})
      this.visible = true
      this.model.parentCode = record != null ? record.toString() : null
    },
    close () {
      this.$emit('close')
      this.enable = true
      this.visible = false
    },
    handleOk () {
      const _this = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          _this.$confirm({
            title: '确认操作',
            content: '是否添加组织?',
            okText: '确认',
            cancelText: '取消',
            onOk: function () {
              _this.confirmLoading = true
              const formData = Object.assign(_this.model, values, { enable: _this.enable })
              addDepartment(formData).then(res => {
              if(res.data.success){
                  _this.$notification.success({
                    message: '提示',
                    description: res.message || '添加组织成功',
                    duration: 3
                  })
                  _this.confirmLoading = false
                  _this.$emit('ok')
                  _this.visible = false
                  _this.enable = true
                } else {
                  _this.$notification.error({
                    message: '错误',
                    description: res.data.errorMessage || '添加组织失败',
                    duration: 3
                  })
                  _this.confirmLoading = false
                }
              }).catch(err => {
                _this.$notification.error({
                  message: '错误',
                  description: ((err.response || {}).data || {}).message || '添加组织失败',
                  duration: 3
                })
                _this.confirmLoading = false
              })
            }
          })
        }
      })
    },
    handleCancel () {
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
